// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-sidebar-card{display:flex;flex-direction:row;align-items:center;color:inherit;border-bottom:1px solid #eff6ff;box-shadow:none;border-radius:0}.article-sidebar-card img{flex:0 0 50px;margin:0 10px}.article-sidebar-card .card-body{padding:0.75rem}.article-sidebar-card .card-body .card-title{font-size:1.1rem;margin-bottom:10px}\n", ""]);
// Exports
module.exports = exports;
